import { useCallback, useState, useEffect } from "react";
import ImpoundsTypeService from "../../../services/administration/impounds";

export const useFetchImpoundTypes = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<any[]>([]);

  const fetchData = useCallback(async () => {
    try {
      const res = await ImpoundsTypeService.fetchAll();

      setData(res);

      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, data };
};
